import Logotype from './Logotype'
import CountrieFlag from './CountrieFlag'
import PlatformIcon from './PlatformIcon'

export { Logotype, CountrieFlag, PlatformIcon }
